import { useCallback } from "react";
import type { DowntimeProperties } from "@/api/cashier";
import { formatTime, parseDuration } from "@/utils/helpers";

export const useFormatDownTime = () => {
  return {
    formatDowntime: useCallback((downtime: DowntimeProperties) => {
      const { start, duration } = downtime;

      const durationMinutes = parseDuration(duration);
      if (durationMinutes === 0) return "24/7";

      const [hours, minutes] = start.split(":").map(Number);
      if (hours === undefined || minutes === undefined) return "24/7";

      const now = new Date();
      const startDate = new Date(
        Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          hours,
          minutes
        )
      );

      const availableStart = new Date(
        startDate.getTime() + durationMinutes * 60_000
      );
      const availableEnd = new Date(startDate.getTime() + 24 * 60 * 60_000);

      return `${formatTime(availableStart)} - ${formatTime(availableEnd)}`;
    }, []),
  };
};
